const initialState = {
    isLogin: false,
    userRole:'',
    menus:'',
    eid:'',
    userInfo: {
        id:1,
        username:'admin',
        privilige: 'small',
        loginTime: '',
        avatar: '',
    }
};
export const actionTypes = {
    USER_LOGIN: "USER_LOGIN",
    USER_LOGIN_RESPONSE: "USER_LOGIN_RESPONSE",
    USER_LOGOUT: "USER_LOGOUT",
    USER_LOGOUT_RESPONSE: "USER_LOGOUT_RESPONSE"
};

export const actions = {
    user_login: function (data) {
        return {
            type: actionTypes.USER_LOGIN,
            data
        }
    },
    user_logout: function (id) {
        return {
            type: actionTypes.USER_LOGOUT,
            id
        }
    },
    timeout_logout:function (data) {
        return {
            type: actionTypes.USER_LOGOUT_RESPONSE,
            data
        }
    },

};

export function reducer(state = initialState, action) {
    switch (action.type) {
        case actionTypes.USER_LOGIN_RESPONSE:
            return {
                ...state, userInfo: action.data.content, isLogin: true, userRole:action.data.userRole, menus:action.data.menus,eid:action.data.eid
            };
        case actionTypes.USER_LOGOUT_RESPONSE:
            return {
                ...state, userInfo: {
                    id:'',
                    username:'',
                    privilige: '',
                    loginTime: '',
                    avatar: '',
                }, isLogin:false,userRole:'',menus:'',eid:''
            };

        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/userReducer.js